<main class="main">
    <div id="main-bg-image" class="main--bg-image"></div>
    <ng-content></ng-content>
</main>